const DEFAULT_UPLOAD_URL =
  "https://theatro-next.vercel.app/api/upload-image";

function pickImageUrl(data) {
  if (!data || typeof data !== "object") return null;
  const url =
    data.url ??
    data.public_url ??
    data.publicUrl ??
    data.imageUrl ??
    data.secure_url ??
    data?.data?.url;
  return typeof url === "string" ? url : null;
}

export async function uploadPosterImageDataUrl(
  dataUrl,
  { uploadUrl = DEFAULT_UPLOAD_URL } = {},
) {
  if (typeof dataUrl !== "string" || !dataUrl.startsWith("data:image/")) {
    throw new Error(
      "Expected a data URL (data:image/png;base64,... or jpeg, gif, webp)",
    );
  }

  const res = await fetch(uploadUrl, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ base64Image: dataUrl }),
  });

  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    throw new Error(
      data.message || data.error || `Upload failed (${res.status})`,
    );
  }

  const url = pickImageUrl(data);
  if (!url) {
    throw new Error("Upload succeeded but no image URL was returned.");
  }
  return url;
}
